import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Service {
    private miniSidenavSubject = new BehaviorSubject<boolean>(false);
    miniSidenav$ = this.miniSidenavSubject.asObservable();

    public isMiniPinned = false;
    public isHovered = false;
    private hoverTimer: any = null;

    setMiniSidenav(state: boolean) {
        this.isMiniPinned = state;
        this.isHovered = false;
        if (this.hoverTimer) {
            clearTimeout(this.hoverTimer);
            this.hoverTimer = null;
        }
        this.applyState();
    }

    toggleMiniSidenav() {
        this.setMiniSidenav(!this.isMiniPinned);
    }

    setMiniHover(hovered: boolean) {
        if (!this.isMiniPinned) {
            return;
        }

        if (this.hoverTimer) {
            clearTimeout(this.hoverTimer);
            this.hoverTimer = null;
        }

        if (hovered) {
            this.hoverTimer = setTimeout(() => {
                this.isHovered = true;
                this.applyState();
            }, 120);
        } else {
            this.hoverTimer = setTimeout(() => {
                this.isHovered = false;
                this.applyState();
            }, 100);
        }
    }

    private applyState() {
        const isVisualMini = this.isMiniPinned && !this.isHovered;
        this.miniSidenavSubject.next(isVisualMini);

        const layout = document.getElementById('layout-container');
        const sidenav = document.getElementById('sidenav-main');

        if (!layout || !sidenav) {
            return;
        }

        layout.classList.toggle('g-sidenav-collapsed', this.isMiniPinned);
        sidenav.classList.toggle('sidenav-mini', isVisualMini);
        sidenav.classList.toggle('sidenav-hover-open', this.isMiniPinned && this.isHovered);
    }
}
